/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {OperationalScopeDTO} from './OperationalScopeDTO';

/**
 * The ChecklistQuantitativeQuestionOperationalScopeDTO model module.
 * @module model/ChecklistQuantitativeQuestionOperationalScopeDTO
 * @version v0
 */
export class ChecklistQuantitativeQuestionOperationalScopeDTO {
  /**
   * Constructs a new <code>ChecklistQuantitativeQuestionOperationalScopeDTO</code>.
   * @alias module:model/ChecklistQuantitativeQuestionOperationalScopeDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistQuantitativeQuestionOperationalScopeDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistQuantitativeQuestionOperationalScopeDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistQuantitativeQuestionOperationalScopeDTO} The populated <code>ChecklistQuantitativeQuestionOperationalScopeDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistQuantitativeQuestionOperationalScopeDTO();
      if (data.hasOwnProperty('operationalScope'))
        obj.operationalScope = OperationalScopeDTO.constructFromObject(data['operationalScope']);
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('answer'))
        obj.answer = ApiClient.convertToType(data['answer'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {module:model/OperationalScopeDTO} operationalScope
 */
ChecklistQuantitativeQuestionOperationalScopeDTO.prototype.operationalScope = undefined;

/**
 * @member {Boolean} enabled
 */
ChecklistQuantitativeQuestionOperationalScopeDTO.prototype.enabled = undefined;

/**
 * @member {Number} answer
 */
ChecklistQuantitativeQuestionOperationalScopeDTO.prototype.answer = undefined;

